import HttpServiceBase from "../httpServiceBase";
import { ISearchResults } from "@myinnsworth/models/ISearchResults";
import { IEnumeratedFolder } from "@myinnsworth/models/storage/IEnumeratedFolder";
import { IStoredItem } from "@myinnsworth/models/storage/IStoredItem";
import { IFileTokenModel } from "./models/IFileTokenModel";

class FilesHttpService extends HttpServiceBase {
    protected get serviceName(): string { return 'files' };
    
    public async fetchLatestUploads(maxResults: number): Promise<IEnumeratedFolder> {
        const files = await this.typedGet<ISearchResults<IStoredItem>>(`latest?maxResults=${maxResults}`);
        return {
            items: files.results
        };
    }

    public async download(): Promise<any> {
        return await this.fileGet(`download`);
    }

    private async getFileDownloadTokenFromFileId(id: string): Promise<string | null> {
        try {
            const result = await this.typedGet<IFileTokenModel>(`token/${id}`);
            return result.token;
        } catch {
            return null;
        }
    }

    private async getFileDownloadToken(file: IStoredItem): Promise<string> {
        const result = await this.typedGet<IFileTokenModel>(`token?${this.fileParamsToQuery(file)}`);
        return result.token;
    }

    public async getDownloadUrlFromFileId(id: string): Promise<string | null> {
        const token = await this.getFileDownloadTokenFromFileId(id);
        if(token === null) return null;
        return `${this.apiBaseUrl}/${this.serviceName}/download/${token}`;
    }

    public async getViewUrlFromFileId(id: string): Promise<string | null> {
        const token = await this.getFileDownloadTokenFromFileId(id);
        if(token === null) return null;
        return `${this.apiBaseUrl}/${this.serviceName}/view/${token}`;
    }

    public async getDownloadUrl(file: IStoredItem): Promise<string> {
        const token = await this.getFileDownloadToken(file);
        return `${this.apiBaseUrl}/${this.serviceName}/download/${token}`;
    }

    public async getViewUrl(file: IStoredItem): Promise<string> {
        const token = await this.getFileDownloadToken(file);
        return `${this.apiBaseUrl}/${this.serviceName}/view/${token}`;
    }

    private fileParamsToQuery(file: IStoredItem): string {
        const idx = file.path.indexOf(file.entityId.toString());
        let folder = file.path.substring(idx + file.entityId.toString().length - 1);
        if(folder.length > 0 && folder.charAt(0) === '/') {
            folder = folder.substring(1);
        }
        
        const params = new Array<string>();
        if(file.id) params.push(`id=${file.id}`);
        if(file.case) params.push(`caseSlug=${file.case.slug}`);
        if(folder)params.push(`folder=${encodeURI(folder)}`);
        if(file.fileName) params.push(`file=${encodeURI(file.fileName)}`);
        if(file.entityId && file.entityId > 0) params.push(`applicantId=${file.entityId}`);
        return params.join('&');
    }
}

const service = new FilesHttpService();
export default service;